import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDefaultSelectableIdol } from '@/shared/store/slices/idolSlice';

/**
 * 偶像選擇器組件
 *
 * @param {Object} props
 * @param {number|string} props.value - 當前選中的偶像 ID（尚未選擇時為 ''）
 * @param {Function} props.onChange - 選擇變更時的回調函數 (idolId: number) => void
 * @param {string} props.className - 額外的 CSS class
 */
function IdolSelector({ value, onChange, className = '' }) {
  const { t } = useTranslation();
  const idolList = useSelector(state => state.idol.list);
  const currentIdolId = useSelector(state => state.user.idolId);

  // 自動初始化：如果沒有選中，預設當前使用中的偶像（跳過停權偶像）；沒有可選的偶像時維持未選
  useEffect(() => {
    if (!value && onChange) {
      const defaultIdol = getDefaultSelectableIdol(idolList, currentIdolId);
      if (defaultIdol) {
        onChange(defaultIdol.idol_id);
      }
    }
  }, [idolList, value, onChange, currentIdolId]);

  return (
    <div className={`col-xl-6 px-0 ${className}`}>
      <div className="bg-primary bg-opacity-75 rounded py-2 px-3">
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <FontAwesomeIcon icon={["fas", "universal-access"]} size="xl" />
            <Form.Label className="text-nowrap fw-bold mb-0">{t('please_select_idol')}</Form.Label>
          </div>
          <Form.Select
            value={value}
            // option 的 value 是字串，轉回數字：與預設選取（idol_id）同型別，送 API 時 idol_id 也一律是數字
            onChange={(e) => onChange(Number(e.target.value))}
            className="flex-grow-1"
          >
            {idolList.map(idol => (
              <option key={idol.idol_id} value={idol.idol_id} disabled={idol.idol_is_suspended}>
                {idol.idol_is_suspended
                  ? t('idol_option_suspended', { name: idol.idol_nick_name })
                  : idol.idol_nick_name}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
    </div>
  );
}

export default IdolSelector;
